import PropTypes from 'prop-types';
import './styles.css';
import React from 'react';
import AvatarWithSelection from '../../../AvatarWithSelection';

const TeamListItem = params => {
  const {
    data: { RecruiterID, FullName, PictureUrl },
    actions: { onSelect, onDeselect },
    isSelectMarkerDisabled,
    selected = false,
  } = params;

  const handleClickSelectMarker = value => {
    if (!isSelectMarkerDisabled && onSelect && onDeselect) {
      if (value) {
        onDeselect(RecruiterID);
      } else {
        onSelect(RecruiterID);
      }
    }
  };

  return (
    <div className="share-list-item">
      <div className="share-list-item__content">
        <div className="share-list-item__block">
          <div className="share-list-item__column share-list-item__column--double">
            <div className="share-list-item__avatar">
              <AvatarWithSelection
                size={60}
                name={FullName}
                image={PictureUrl}
                selected={selected}
                onSelect={handleClickSelectMarker}
              />
            </div>

            <div className="share-list-item__main">
              <span className="share-list-item__name">{FullName}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

TeamListItem.propTypes = {
  data: PropTypes.object,
  actions: PropTypes.object,
};

export default TeamListItem;
